module.exports = __webpack_public_path__ + "static/media/ico-step5-forecast.a7a9d4fc.svg";